import { NavigateNext } from "@mui/icons-material";
import { Breadcrumbs, Link } from "@mui/material";

interface Props {
  handleNavIcon: (level?: number) => void,
  navIconLabel?: string | string[],
}

export const BreadcrumbsComponent = ({ handleNavIcon, navIconLabel }: Props) => {
  const labels: string[] = (Array.isArray(navIconLabel) ? navIconLabel :
    [navIconLabel]).filter((label): label is string => label !== undefined);

  return (
    <Breadcrumbs
      separator={<NavigateNext fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ mb: 2 }}
    >
      {labels.map((label, index) => (
        <Link
          sx={{ cursor: 'pointer' }}
          underline="hover"
          key={index}
          color="inherit"
          onClick={() => handleNavIcon(labels.length - index)}
          data-automation={index === 0 ? 'back-back-btn' : 'back-btn'}
        >
          {label}
        </Link>
      )) || []}
    </Breadcrumbs>
  );
}